import computeClassName from '../../../../../utils/computeClassName';
import { KEYS } from '../../../../../l18n/constants';
import { useL18nContext } from '../../../ContextProvider/L18n';
import { usePartnerSearchContext } from '../../../ContextProvider/Partner/Search';
import PartnerSearchHeader from './Header';
import PartnerSearchMain from './Main';
import ProcessingOverlay from '../../../ProcessingOverlay';

const constants = Object.freeze({
  CLASSNAME_BASE: 'flex flex-col h-full w-full'
});

export default function PartnerSearch({className}){
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedProcessingTitle = getTranslationFor(KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS);
  const { isUserGeoLocationInProgress, isPartnerSearchInProgress, isUserSavedPartnersFetchingInProgress } = usePartnerSearchContext();

  return (
    <div className={computedClassName}>
      <PartnerSearchHeader className="__MR_HOME_SEARCH_HEADER__ flex-shrink-0"/>
      <PartnerSearchMain className="__MR_HOME_SEARCH_MAIN__ flex-grow"/>
      <ProcessingOverlay className="__MR_HOME_SEARCH_OVERLAY__"
                         isVisible={ isUserGeoLocationInProgress || isPartnerSearchInProgress || isUserSavedPartnersFetchingInProgress}
                         processingTitle={translatedProcessingTitle}
      />
    </div>
  );
}
